import createLucideIcon from '../createLucideIcon';

const ArrowBigDown = createLucideIcon('ArrowBigDown', [
  ['path', { d: 'M9 3h6v11h4l-7 7-7-7h4z', key: '6dczpq' }],
]);

export default ArrowBigDown;
